import React from 'react';
import { Wrench, Eye, Shield, Lightbulb, Sparkles, Star } from 'lucide-react';

// Services Section
export const ServicesSection = () => {
  const services = [
    {
      icon: Wrench,
      title: 'Renovácia svetlometov',
      description: 'Odstránenie matnosti, zažltnutia a škrabancov. UV ochrana pre dlhodobý výsledok.',
      features: ['Polymerizácia', 'Leštenie', 'UV náter'],
    },
    {
      icon: Eye,
      title: 'Výmena plexiskiel',
      description: 'Profesionálna výmena poškodených plexiskiel svetlometov všetkých značiek.',
      features: ['Originálne diely', 'Presné tesnenie', 'Záruka'],
    },
    {
      icon: Shield,
      title: 'PPF fólia na svetlá',
      description: 'Ochranná fólia pred kameňmi, UV žiarením a poškriabaním.',
      features: ['Číra fólia', 'Tónovaná fólia', 'Dlhá životnosť'],
    },
    {
      icon: Lightbulb,
      title: 'LED & Bi-LED projektory',
      description: 'Montáž moderného LED osvetlenia pre lepšiu viditeľnosť a dizajn.',
      features: ['DRL', 'Bi-LED', 'Xenón'],
    },
    {
      icon: Sparkles,
      title: 'Ambientné osvetlenie',
      description: 'Luxusné osvetlenie interiéru s individuálnymi farebnými nastaveniami.',
      features: ['RGB pásky', 'App ovládanie', 'Profesionálna montáž'],
    },
    {
      icon: Star,
      title: 'Hviezdny strop',
      description: 'Prémiový hviezdny strop pre nezabudnuteľný zážitok z jazdy.',
      features: ['Optické vlákna', 'Stmievanie', 'Vlastný dizajn'],
    },
  ];

  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#00BFFF] mb-4">
            Naše služby
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl tracking-tight font-medium">
            Čo pre vás môžeme urobiť
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              data-testid={`service-card-${index}`}
              className="bg-white/5 border border-white/10 rounded-xl p-8 hover:-translate-y-1 hover:border-[#00BFFF]/50 transition-all duration-300 group"
            >
              <div className="w-12 h-12 rounded-lg bg-[#00BFFF]/10 flex items-center justify-center mb-6 group-hover:bg-[#00BFFF]/20 transition-colors">
                <service.icon className="w-6 h-6 text-[#00BFFF]" strokeWidth={1.5} />
              </div>
              
              <h3 className="text-xl font-medium mb-3">{service.title}</h3>
              <p className="text-zinc-400 text-sm mb-4">{service.description}</p>
              
              <div className="flex flex-wrap gap-2">
                {service.features.map((feature, idx) => (
                  <span 
                    key={idx}
                    className="text-xs px-3 py-1 bg-white/5 rounded-full text-zinc-400"
                  >
                    {feature}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
